import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgViewMoreRestaurants',
})
export default class CmgViewMoreRestaurants extends Vue {
  @Prop({ required: true, default: false, type: Boolean })
  showMoreRestaurants!: boolean;

  @Prop({ required: true, type: String })
  viewMoreRestaurants!: string;

  @Prop({ required: true, type: String })
  viewLessRestaurants!: string;
}
